import dayjs from 'dayjs'
import { isUndefined } from 'lodash'
import { useCallback, useEffect } from 'react'
import { useGetRecurringPaymentApiV1RecurringPaymentGet } from '../api/gen/base'
import { useProfileStore } from '../store/storeProfile'
import { useWrapperStore } from '../store/storeWrapper'
import { useSessionStorage } from './useSessionStorage'

export const usePackageSubscription = () => {
    const { balance } = useProfileStore((state) => state)
    const { isTempUser, setIsOpenUpdateSubscriptionDialog } = useWrapperStore((state) => state)
    const [shouldOpenUpdateSubscriptionDialog, setShouldOpenUpdateSubscriptionDialog] =
        useSessionStorage('shouldOpenUpdateSubscriptionDialog', true)

    const { data: subscriptionData } = useGetRecurringPaymentApiV1RecurringPaymentGet()

    const isActiveSubscriptionWithEmptyBalance =
        !isTempUser &&
        !!subscriptionData?.is_active &&
        dayjs(subscriptionData?.next_payment_date).isAfter(new Date()) &&
        !isUndefined(balance) &&
        balance <= 0

    useEffect(() => {
        if (shouldOpenUpdateSubscriptionDialog && isActiveSubscriptionWithEmptyBalance) {
            setIsOpenUpdateSubscriptionDialog(true)
            setShouldOpenUpdateSubscriptionDialog(false)
        }
    }, [isActiveSubscriptionWithEmptyBalance])

    const promoteUpdatePackageSubscription = useCallback(() => {
        if (isTempUser) {
            return
        }

        setIsOpenUpdateSubscriptionDialog(isActiveSubscriptionWithEmptyBalance)
    }, [isActiveSubscriptionWithEmptyBalance])

    return {
        promoteUpdatePackageSubscription,
        subscriptionData,
    }
}
